import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Popup,
  I18n,
  Link,
  TextInput,
  Button,
  Heading,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const validate = (confirmationCode, isCodeInvalid, isDirty) => {
  if (isCodeInvalid) {
    return 'settings.notifications.wrongCodeError';
  }

  if (!confirmationCode && isDirty) {
    return 'settings.notifications.emptyCodeError';
  }

  return null;
};

class ConfirmationCodePopup extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      confirmationCode: '',
      isDirty: false,
      error: null,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.isOpened && !props.isOpened) {
      this.setState({
        confirmationCode: '',
        isDirty: false,
        error: null,
      });
    } else {
      this.setState((prevState) => ({
        error: validate(
          prevState.confirmationCode,
          props.isCodeInvalid,
          prevState.isDirty,
        ),
      }));
    }
  }

  handleCodeChange = (confirmationCode) => {
    const {
      isCodeInvalid,
      resetPointCodeValidation,
    } = this.props;

    this.setState({
      confirmationCode,
      isDirty: true,
      error: validate(confirmationCode, false, true),
    }, () => isCodeInvalid && resetPointCodeValidation());
  };

  closePopup = () => {
    const {
      resetPointCodeValidation,
      cancelConfirmation,
    } = this.props;

    if (!this.isLoading()) {
      resetPointCodeValidation();
      cancelConfirmation();
    }
  };

  isSubmitDisabled() {
    const {
      confirmationCode,
      error,
    } = this.state;

    return !!error || !confirmationCode;
  }

  isLoading() {
    const {
      isChecking,
      isCodeSending,
    } = this.props;

    return isCodeSending || isChecking;
  }

  render() {
    const {
      type,
      isOpened,
      confirmCode,
      resendCode,
      pointValue,
    } = this.props;

    const {
      confirmationCode,
      error,
    } = this.state;

    return (
      <Popup
        opened={isOpened}
        onClose={this.closePopup}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();

            if (!this.isLoading() && !this.isSubmitDisabled()) {
              confirmCode(confirmationCode);
            }
          }}
        >
          <Heading className={cx('title')} level={1}>
            <I18n path={`settings.points.${type}.confirmTitle`} />
          </Heading>
          <Heading className={cx('subtitle')} level={5}>
            <I18n
              path="settings.notifications.confirmation"
              vars={{ value: pointValue }}
            />
          </Heading>
          <div className={cx('inputWrapper')}>
            <TextInput
              size="big"
              className={cx('textInput', { fail: !!error })}
              value={confirmationCode}
              onChange={this.handleCodeChange}
            />
            {error
              && (
              <div className={cx('error')}>
                <I18n path={error} />
              </div>
              )}
            <Link
              className={cx('tryAgainLink', {
                hidden: this.isLoading(),
              })}
              onClick={resendCode}
            >
              <I18n path="settings.notifications.tryAgain" />
            </Link>
          </div>
          <div className={cx('doneButtonWrapper')}>
            <Button
              className="big"
              type="submit"
              disabled={this.isSubmitDisabled()}
              isLoading={this.isLoading()}
            >
              <I18n path="common.done" />
            </Button>
          </div>
        </form>
      </Popup>
    );
  }
}

ConfirmationCodePopup.propTypes = {
  pointValue: PropTypes.string,
  type: PropTypes.string,
  isOpened: PropTypes.bool,
  isCodeInvalid: PropTypes.bool,
  isChecking: PropTypes.bool,
  isCodeSending: PropTypes.bool,
  confirmCode: PropTypes.func,
  resetPointCodeValidation: PropTypes.func,
  resendCode: PropTypes.func,
  cancelConfirmation: PropTypes.func,
};

export default ConfirmationCodePopup;
